import { render, staticRenderFns } from "./OtherShop.vue?vue&type=template&id=08ad5ccd"
import script from "./OtherShop.vue?vue&type=script&lang=js"
export * from "./OtherShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports